import React from "react";

import * as Components from "../../components";

export interface AssociationFailedProps {
    helpDescEmail: string
    onBackToLogin()
}
export const AssociationFailed: React.FunctionComponent<AssociationFailedProps> = (props) => {
    return <Components.LayoutBlock fill>
        <Components.LayoutBlock>
            <Components.LayoutBlock fill className="yum-sso-self-service-message">
                <div>There has been an issue associating a Tracks user with Yum ID</div>
                <div>Please contact {props.helpDescEmail}</div>
            </Components.LayoutBlock>
        </Components.LayoutBlock>
        <Components.Button onClick={props.onBackToLogin}>
            Go To Login
        </Components.Button>
    </Components.LayoutBlock>
}
